import { render, staticRenderFns } from "./sfc-header-student-loans.vue?vue&type=template&id=e40d15aa&scoped=true&lang=pug&"
import script from "./sfc-header-student-loans.vue?vue&type=script&lang=js&"
export * from "./sfc-header-student-loans.vue?vue&type=script&lang=js&"
import style0 from "./sfc-header-student-loans.vue?vue&type=style&index=0&id=e40d15aa&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e40d15aa",
  null
  
)

export default component.exports